/* eslint-disable react/no-unescaped-entities,max-len,react-hooks/exhaustive-deps */
import React, {
  useEffect, useState,
} from 'react';
import { useInView } from 'react-intersection-observer';
import Radium, { Style } from 'radium';

import styles from './whatsnew.module.css';
import animateStyles from '../animate.module.css';

const assertBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;

const WhatsNew = () => {
  const [animatePhone1, doAnimatePhone1] = useState(false);
  const [animatePhone2, doAnimatePhone2] = useState(false);
  const [animatePhone3, doAnimatePhone3] = useState(false);
  const phone1InViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const phone2InViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const phone3InViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const whatsNewInViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const windowWith = window.innerWidth;

  useEffect(() => {
    const phoneAnimate = () => {
      (!animatePhone1) && doAnimatePhone1(true);
      (!animatePhone2) && setTimeout(() => { // add .animate to each after 200ms
        doAnimatePhone2(true);
      }, 250);
      (!animatePhone3) && setTimeout(() => { // add .animate to each after 200ms
        doAnimatePhone3(true);
      }, 500);
    };
    if (windowWith >= 769 && whatsNewInViewState.inView) {
      phoneAnimate();
    }
  }, [windowWith, whatsNewInViewState.inView]);

  return (
    <>
      <Style
        scopeSelector={`.${styles['whats-new']}::before`}
        rules={{
          backgroundImage: `url('${assertBaseUrl}/images/blobs.png')`,
          backgroundRepeat: 'no-repeat',
        }}
      />
      <Style
        scopeSelector={`.${styles['whats-new']}::after`}
        rules={{
          backgroundImage: `url('${assertBaseUrl}/images/blobs2.png')`,
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div className={styles['whats-new']} ref={whatsNewInViewState.ref}>
        <div className={styles['phone--1']} ref={phone1InViewState.ref}>
          <img
            src={`${assertBaseUrl}/images/iphone3_1574120302.5339_1574120302.9379.png`}
            alt=""
            className={`${animateStyles.fadein} ${(phone1InViewState.inView && windowWith <= 768) || animatePhone1 ? animateStyles.animate : ''}`}
          />
        </div>
        <div className={styles['phone--2']} ref={phone2InViewState.ref}>
          <img
            src={`${assertBaseUrl}/images/iphone2_1574120305.9814_1574120306.3936.png`}
            alt=""
            className={`${animateStyles.fadein} ${(phone2InViewState.inView && windowWith <= 768) || animatePhone2 ? animateStyles.animate : ''}`}
          />
        </div>
        <div className={styles['phone--3']} ref={phone3InViewState.ref}>
          <img
            src={`${assertBaseUrl}/images/iphone1_1574120309.6106_1574120310.0467.png`}
            alt=""
            className={`${animateStyles.fadein} ${(phone3InViewState.inView && windowWith <= 768) || animatePhone3 ? animateStyles.animate : ''}`}
          />
        </div>
        <div className={`${styles['grid--4']} ${styles['intro-title']} ${styles['center-col']}`}>
          <img
            src={`${assertBaseUrl}/images/fff-app-icon.png`}
            alt=""
            className={styles.app__icon}
          />
          <h2>What's New!</h2>
          <hr className={styles.hr1} />
        </div>
        <div className={`${styles['grid--5']} ${styles.discoverfff} ${styles['center-col']}`}>
          <h3>Customize Your Box</h3>
          <p>
            Pick the products you love. (Or let us surprise you!)
          </p>
        </div>
        <div className={`${styles['grid--6']} ${styles.explorebox} ${styles['center-col']}`}>
          <h3>Shop Exclusive Sales</h3>
          <p>Exclusive sales and discounts for members only.</p>
        </div>
        <div className={`${styles['grid--7']} ${styles['addons-edit']} ${styles['center-col']}`}>
          <h3>Check Your Box Status</h3>
          <p>Stay up-to-date on when your box will arrive.</p>
        </div>
        <div className={styles.store}>
          <a href={process.env.REACT_APP_MOBILE_APP_IOS_URL} className="">
            <img
              src={`${assertBaseUrl}/images/icon-apple-store.png`}
              alt=""
              className={`${animateStyles.hoverbtn} ${styles.apple_store}`}
            />
          </a>
          <a href={process.env.REACT_APP_MOBILE_APP_ANDROID_URL} className="">
            <img
              src={`${assertBaseUrl}/images/icon-google-store_1574120297.6679_1574120298.1544.png`}
              alt=""
              className={`${animateStyles.hoverbtn} ${styles.google_play}`}
            />
          </a>
        </div>
      </div>
    </>
  );
};

export default Radium(WhatsNew);
